import { logger } from './logger'
import { toasterUtil } from './toaster-util'

export type BackendHTTPError = {
  message: string
  code: number
}

export const errorUtil = {
  logError: (err: unknown): void => {
    logger.error(err instanceof Error ? err : String(err))
  },
  logErrorWithMeta: (err: unknown, meta: Record<string, unknown>): void => {
    if (err instanceof Error) {
      logger.error(err, meta)
    } else {
      logger.error(String(err), meta)
    }
  },
  parseHttpError: (error: any): BackendHTTPError => {
    return {
      message: error.message ?? error.toString(),
      code: error.code ?? 500,
    }
  },
  handleHttpError: (error: any): void => {
    const err = errorUtil.parseHttpError(error)
    if (err.code >= 500) {
      toasterUtil.error(err.message)
    } else {
      toasterUtil.warn(err.message)
    }
  },
}
